module.exports = __webpack_public_path__ + "img/KUCE-CROP-09.6b853248.png";